import { IonLoading, IonToast } from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { findProfileOrganization } from "../../../store/userProfileOrganization/actions/findProfileOrganizations";

export const AssignOrganizationStatus = () => {
    const dispatch = useDispatch();
    const assignOrganizationStatus = useSelector((state: RootState) => state.userProfileOrganization.assignOrganizationsStatus);
    const userId = useSelector((state: RootState) => state.userProfileOrganization.user.id);
    const profileId = useSelector((state: RootState) => state.userProfileOrganization.profile.id);

    const handleFinishedAssign = () => {
        dispatch(findProfileOrganization({userId: userId, profileId: profileId}));
    }

    return (
        <>
        <IonLoading isOpen={assignOrganizationStatus === "pending"} message={"Asignando clientes..."} />

            {assignOrganizationStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Las plantas fueron asignadas correctamente"
                    position="bottom"
                    duration={1500}
                    color="success"
                />
            )}

            {assignOrganizationStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al asignar las plantas"
                    position="bottom"
                    duration={1500}
                    color="danger"
                />
            )}
        </>
    );
};
